import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';
import { Logging } from '@newrelic/browser-agent/features/logging';
import { Metrics } from '@newrelic/browser-agent/features/metrics';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const newRelicOptions = {
  init: {
    distributed_tracing: {
      enabled: true,
      cors_use_newrelic_header: true,
      cors_use_tracecontext_headers: true,
      allowed_origins: [
        import.meta.env.VITE_APP_onBackstageAPI,
        import.meta.env.VITE_APP_onProductsAPI,
        import.meta.env.VITE_APP_onBackstage,
        import.meta.env.VITE_APP_onForce,
      ],
    },
    privacy: {
      cookies_enabled: true,
    },
    session_replay: {
      enabled: true,
      sampling_rate: 0.0, // Disable general session replay
      error_sampling_rate: 100.0, // Capture 100% of sessions with errors
    },
    ajax: {
      deny_list: ['*.nr-data.net', '*.cookielaw.org', '*.hotjar.io', '*.google-analytics.com'],
    },
    logging: {
      enabled: true,
      level: 'INFO',
    },
  },
  info: {
    beacon: import.meta.env.VITE_APP_NEW_RELIC_BEACON,
    errorBeacon: import.meta.env.VITE_APP_NEW_RELIC_BEACON,
    licenseKey: import.meta.env.VITE_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: import.meta.env.VITE_APP_NEW_RELIC_APPLICATION_ID,
    sa: 1,
  },
  loader_config: {
    accountID: import.meta.env.VITE_APP_NEW_RELIC_ACCOUNT_ID,
    trustKey: import.meta.env.VITE_APP_NEW_RELIC_ACCOUNT_ID,
    agentID: import.meta.env.VITE_APP_NEW_RELIC_APPLICATION_ID,
    licenseKey: import.meta.env.VITE_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: import.meta.env.VITE_APP_NEW_RELIC_APPLICATION_ID,
  },
  features: [Metrics, Logging, GenericEvents],
};

export const newRelicAgent = new BrowserAgent(newRelicOptions);
